import { computed } from 'vue'
import type { AnimationFrameFunction } from './useCarouselNew'
import { useIsMobile } from '@/plugins/is-mobile.ts'

export function useAnimationScale(): AnimationFrameFunction {
    const isMobile = useIsMobile(478)
    const translateCoefficient = computed(() => (isMobile.value ? 1 : 40))

    return (
        item: HTMLElement,
        itemParent: HTMLElement,
        container: HTMLElement
    ) => {
        const containerBcr = container.getBoundingClientRect()
        const itemBcr = itemParent.getBoundingClientRect()

        const containerWidth = containerBcr?.width || 0
        const itemWidth = itemBcr.width
        const distance = itemBcr.left - containerBcr?.left + itemWidth / 2
        const ratio =
            (containerWidth - 2 * Math.abs(distance - containerWidth / 2)) /
            containerWidth

        // optimize for out-of-view items
        if (ratio < -1) {
            return
        }

        const reverseRatio = 1 - ratio

        const scale = isMobile.value
            ? 1 - reverseRatio * 0.15
            : Math.max(ratio, 0.7)

        const translate =
            Math.sin(reverseRatio * 2.8) *
            translateCoefficient.value *
            Math.sign(distance - containerWidth / 2)

        item.style.transform = `scale3d(${scale}, ${scale}, ${scale}) translate3d(${translate}%, 0, 0)`
    }
}
